import helpers from '../util/helpers';
import * as constants from '../util/constants';

// Modules
import globalSearch from './modules/globalSearch';
import header from './modules/header';
import selectHotel from './modules/selectHotel';
import searchAccommodations from './modules/searchAccommodations.js';
import searchLocations from './modules/searchLocations.js';
import searchOccasions from './modules/searchOccasions.js';
import searchGuests from './modules/searchGuests.js';
import loadInstagramFeeds from './modules/loadInstagramFeeds';

// Components
import bookVenue from './modules/bookVenue';
import bookingWidgets from './components/bookingWidgets';
import accordions from './components/accordions';
import dropdowns from './components/dropdowns';
import flipCard from './components/flipCard';
import modals from './components/modals';
import selects from './components/selects';
import sliders from './components/sliders';
import tabs from './components/tabs';

// ACF Blocks

export default {
  init() {
    // calculate the scrollbar width then store in css variable
    // this is used for vw not include scrollbar in windows
    // example: width: calc(100vw - var(--scrollbar-width))
    document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + 'px');

    let auth0Settings = {};

    if (window.EVT_Stays_Membership) {
      auth0Settings = window.EVT_Stays_Membership.auth0Settings || {};
    }

    $(document).on('click', '.login-join-trigger, .login-join-close, .join-trigger, .trigger-evtstays-login, .trigger-pgr-login, .trigger-evtstays-join, .trigger-pgr-join', function(e) {
      e.preventDefault();
      const _this = $(this);

      if (auth0Settings.isEnabled) {
        if (_this.is('.trigger-evtstays-join, .trigger-pgr-join, .join-trigger')) {
          window.EVT_Stays_Membership.auth0Settings.join();
        } else {
          window.EVT_Stays_Membership.auth0Settings.login();
        }

        return false;
      }
    });

    // Modules
    globalSearch.init();

    // Components
    accordions.init();
    bookingWidgets.init();
    dropdowns.init();
    flipCard.init();
    modals.init();
    selects.init();
    sliders.init();
    tabs.init();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    // Balance elements
    helpers.onWindowEvents(() => {
      helpers.equalHeightElements($('.balance-elements'), false, 30);
    }, 1, 1, 1, 0);

    $(document).on(constants.EVENT_BALANCE_ELEMENTS, () => {
      helpers.equalHeightElements($('.balance-elements'), false, 30);
    });

    // scroll to element if url has a hash
    helpers.onWindowEvents(() => {
      if (location.hash.length !== 0) {
        const hash = location.hash;

        try {
          if ($(hash).length) {
            $(hash).goToElement(undefined);
          }
        } catch (e) {
          return false;
        }
      }
    }, 0, 1, 0, 0);

    // Modules
    header.finalize();
    loadInstagramFeeds.finalize();

    // Components
    bookVenue.finalize();

    selectHotel();
    searchAccommodations();
    searchLocations();
    searchOccasions();
    searchGuests();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js